<div class="flex-main-container">
  <div class="container main-container">
    <div class="row">
      <div *ngIf="generalTmsError.length > 0"
           class="col-xs-12 general-error"
           role="alert">
        <wdpr-messages [values]="generalTmsError"></wdpr-messages>
      </div>
      <div class="col-xs-12">
        <h1>{{ 'assign-page.title' | translate }}</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <com-html [value]="'assign-page.description' | translate"></com-html>
      </div>
    </div>
    <div class="row entitlements">
      <form #entitlementsForm="ngForm">
        <div *ngFor="let entitlement of entitlements; let i = index;" class="col-xs-12 entitlement-container">
          <div class="inner-border"></div>
          <div class="row entitlement">
            <div class="col-xs-12 entitlement-visual-id">
              <span>{{ 'assign-page.id-number' | translate }} </span>
              <span class="guestSensitive">{{entitlement.entitlementId}}</span>
            </div>
            <div class="col-xs-12 col-sm-4 entitlement-info">
              <span class="col-xs-1 di di16" [ngClass]="entitlement.icon"></span>
              <span class="col-xs-11">
              <span class="product-name" aria-hidden="true">{{entitlement.productName}}</span>
                <div *ngIf="entitlement.supplements && entitlement.supplements.length > 0" class="supplement" aria-hidden="true">
                  <span class="addon-title">{{ 'assign-page.addons-label' | translate }}&nbsp;</span>
                  <span class="addon-names">{{ getAddOnNames(entitlement.supplements) }}</span>
                </div>
                <div *ngIf="entitlement.expirationDate">
                  {{ 'assign-page.pass-expiration' | translate: [entitlement.expirationDate] }}
                </div>
            </span>
            <h2 class="sr-only">{{ getScreenReaderProductAddonsLabels(entitlement) }}</h2>
            </div>
            <div class="col-xs-12 col-sm-offset-1 col-sm-7 entitlement-assignments">
              <div *ngIf="!entitlement.isAnnualPass && !entitlement.isLinked">
                <div class="col-xs-12 col-sm-6 input-container">
                  <wdpr-input label="{{ 'assign-page.input-first-name-placeholder' | translate }}"
                              customAriaLabel="{{ 'assign-page.input-first-name-placeholder' | translate }} {{ i }}"
                              name="firstName_{{entitlement.entitlementId}}"
                              [maxlength]="nameInputsLength.firstName"
                              [(ngModel)]="entitlement.assignedTo.firstName"
                              class="guestSensitive"
                              [ngClass]="{'invalid': firstName.invalid}"
                              [ngModelOptions]="{updateOn: 'blur'}"
                              required
                              pattern="^(?! )[a-zA-Z-\s]+[a-zA-Z]+$"
                              appDirtyWordsValidator
                              ngDefaultControl
                              #firstName="ngModel">
                  </wdpr-input>
                  <div *ngIf="firstName.invalid && firstName.touched"
                       role="alert">
                    <span *ngIf="firstName.errors" class="error-message">
                      <span class="di di-alert"></span>
                      {{ getVisualIdInputErrorKey(firstName.errors, 'firstName') | translate }}
                    </span>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 input-container">
                  <wdpr-input label="{{ 'assign-page.input-last-name-placeholder' | translate }}"
                              customAriaLabel="{{ 'assign-page.input-last-name-placeholder' | translate }} {{ i }}"
                              name="lastName_{{entitlement.entitlementId}}"
                              [maxlength]="nameInputsLength.lastName"
                              class="guestSensitive"
                              [(ngModel)]="entitlement.assignedTo.lastName"
                              [ngClass]="{'invalid': lastName.invalid}"
                              [ngModelOptions]="{updateOn: 'blur'}"
                              required
                              appDirtyWordsValidator
                              ngDefaultControl
                              pattern="^(?! )[a-zA-Z-\s]+[a-zA-Z]+$"
                              #lastName="ngModel">
                  </wdpr-input>
                  <div *ngIf="lastName.invalid && lastName.touched"
                       role="alert">
                    <span *ngIf="lastName.errors" class="error-message">
                      <span class="di di-alert"></span>
                      {{ getVisualIdInputErrorKey(lastName.errors, 'lastName') | translate }}
                    </span>
                  </div>
                </div>
              </div>
              <div *ngIf="entitlement.isAssigned && (entitlement.isAnnualPass || entitlement.isClaimed)"
                class="col-xs-offset-1 col-xs-11 col-sm-offset-0 col-sm-12 assignee guestSensitive">
                {{ 'assign-page.assigned-to' | translate }}
                <div>{{entitlement.assignedTo.fullName}}</div>
              </div>
            </div>
            <div [hidden]="entitlement.isTicket || (entitlement.isAnnualPass && entitlement.isLinked)"
                 class="col-xs-12 entitlement-link-check">
              <wdpr-checkbox alignment="top"
                             name="acceptLink_{{entitlement.entitlementId}}"
                             [checked]="shouldAutocompleteLinkCheckbox(entitlement)"
                             [attr.disabled]="(entitlement.isLinked) ? '' : null"
                             (checked-changed)="changeEntitlementLinkStatus($event, entitlement)"
                             [attr.tabindex]="entitlement.isTicket ? 0 : 1"
                             ngDefaultControl
                             analyticsTrackLink='{"linkId":"{{&apos;{{&apos;}}LOB}}_TicketAPSpecialEventClaim_OwnershipAcknowledgement","store":"{{&apos;{{&apos;}}LOB}}{{&apos;{{&apos;}}storeType}}"}'>
                {{ 'assign-page.input-confirm-link' | translate }}
              </wdpr-checkbox>
            </div>
            <div *ngIf="entitlement.isTicket || (entitlement.isAnnualPass && entitlement.isLinked)"
                 class="col-xs-12 entitlement-link-check alert-message"
                 role="alert">
                 <div *ngIf="entitlement.isLinked">
                    <span class="di di14 di-scary-consideration-yellow"></span>
                    <span class="info-message-text">{{ 'assign-page.shared-claim' | translate }}</span>
                 </div>
                 <div *ngIf="!entitlement.isLinked">
                    <span class="di di14 di-checkmark"></span>
                    <span class="info-message-text">{{ 'confirmation-page.primaryGuestResponsible' | translate }}</span>
                 </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <app-pep-syndicated-footer></app-pep-syndicated-footer>
  <div class="container-fluid navbar-fixed-bottom">
    <div class="container">
      <div class="row">
        <div class="col-xs-6">
          <wdpr-button theme="secondary"
                       (click)="backToVidPage()"
                       tabindex="0"
                       analyticsTrackLink='{"linkId":"{{&apos;{{&apos;}}LOB}}_TicketAPSpecialEventClaim_Back","store":"{{&apos;{{&apos;}}LOB}}{{&apos;{{&apos;}}storeType}}"}'>
            {{ 'assign-page.back-cta' | translate }}
          </wdpr-button>
        </div>
        <div class="col-xs-6 text-right">
          <wdpr-button theme="primary"
                       [disabled]="entitlementsForm.invalid || isAssignmentInProgress || entitlementsForm.status === 'PENDING'"
                       (click)="assignEntitlementsToGuest()"
                       tabindex="0"
                       analyticsTrackLink='{"linkId":"{{&apos;{{&apos;}}LOB}}_TicketAPSpecialEventClaim_Confirm","store":"{{&apos;{{&apos;}}LOB}}{{&apos;{{&apos;}}storeType}}"}'>
            <span *ngIf="!isAssignmentInProgress">{{ 'assign-page.confirm-cta' | translate }}</span>
            <wdpr-loading *ngIf="isAssignmentInProgress" size="small"></wdpr-loading>
          </wdpr-button>
        </div>
      </div>
    </div>
  </div>
</div>
